<template>
  <div class="app-container">
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" size="mini" label-width="90px" >
        <div class="formItemBox">
          <el-form-item label="一级货主:" >
            <el-select v-model="searchFrom.primaryCustomerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:" >
            <el-select v-model="searchFrom.customerTaxId" clearable filterable placeholder="请选择">
              <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="searchFrom.productType" clearable @change="productTypeChange" placeholder="请选择" filterable>
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:" >
            <el-select v-model="searchFrom.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" >
            <el-select v-model="searchFrom.specification" clearable @change='specificationChange' placeholder="请选择" filterable>
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="searchFrom.model" @change="modelChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="件数:" >
            <el-select v-model="searchFrom.number" clearable placeholder="请选择">
              <el-option v-for="(item, index) in numberOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓位:">
            <el-select v-model="searchFrom.warehouseId" size="mini" placeholder="请选择仓位名" clearable>
              <el-option v-for="(item,index) in CWData" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车船号:" >
            <el-input class="ipt" v-model="searchFrom.plateNumber" placeholder="请输入车船号" size="mini" ></el-input>
          </el-form-item>
        </div>
        <div class="searchBtnBox" style="margin: 0;padding-bottom: 10px;">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00cP008B001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00cP008B002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="turnGoodsClick" btnCode="00cP008B003" v-if="btnFlg[2]">转货清单</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clearBtn" btnCode="00cP008B004" v-if="btnFlg[3]">盘盈盘亏</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportClick" btnCode="00cP008B005" v-if="btnFlg[4]">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="turnClick" btnCode="00cP008B006" v-if="btnFlg[5]">移库</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="importFn" btnCode="00cP008B007" v-if="btnFlg[6]">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="templateImport" btnCode="00cP008B008" v-if="btnFlg[7]">模板导出</el-button>
          </el-form-item>
          <el-form-item>
            <div style="display: flex;">
              <div style="display: flex;">
                <div>总吨数：</div>
                <div style="color:red;">{{Number(totalAllWeight).toFixed(4)}}</div>&nbsp;&nbsp;吨
              </div>
              <div style="margin-left:20px;display: flex;">
                <div>总件数：</div>
                <div style="color:red;">{{totalNumber}}</div>&nbsp;&nbsp;件
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%" style="width: 100%; margin-top: 10px" center :fit='true' @row-click="handleRowClick" @current-change="handleTabCurrentChange" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center" fixed></el-table-column>
        <el-table-column width="100" label="操作" align="center" fixed>
          <template v-slot='scope'>
            <el-button type="text" @click="quXiaoYuZhuan(scope.$index,scope.row)" v-if="scope.row.isYuanZhuanFlag">取消预转</el-button>
            <el-button type="text" @click="PreSelect(scope.$index,scope.row)" v-else>预转</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
        <el-table-column prop="inAvgWeight" label="入库件重（吨）" align="center" width="120"></el-table-column>
        <el-table-column prop="avgWeight" label="平均件重（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockWeight" label="理重（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" align="center" width="120"></el-table-column>
        <el-table-column prop="inStockTime" label="入库时间" align="center" width="180"></el-table-column>
        <el-table-column prop="plateNumber" label="车船号" align="center" width="120"></el-table-column>
        <el-table-column prop="shipForecastNo" label="预报编号" align="center" width="230"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom.pageNo" :page-sizes="[10,20,30,40,50]" :page-size="searchFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 转货弹框 -->
    <el-dialog title="预选清单" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="turnMark" @close="closeDialog" width="90%" center>
      <div v-loading='turnLoading'>
        <div class="bigBox">
          <div>
            <el-button type="primary" @click="clearArr">清空</el-button>
            <!-- <p style="display:inline-block;margin-left:10px;" v-if="disShow">控货剩余量<span class="numbers">{{ residue }}</span>吨 <span>转货总重量：<span class="numbers">{{changeAllWeight}}</span>吨</span></p> -->
            <p style="display:inline-block;margin-left:10px;">
              <span>转货总重量：
                <span class="numbers" style="color:red;">{{changeAllWeight}}</span>吨 /
                <span class="numbers" style="color:red;">{{changeAllNumber}}</span>件
              </span>

              <span style="margin-left:20px;" v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].isEnable==1">未提量：
                <span v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].controlWeight==1"><span class='numbers' style="color:red;">{{turnGoodsTableList[0].controlStockWeight}}</span>吨</span>
                <span v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].controlPiece==1">{{turnGoodsTableList[0].controlWeight==1?'/':''}}<span class='numbers' style="color:red;">{{turnGoodsTableList[0].controlStockNumber}}</span>件</span>
              </span>
              <span style="margin-left:20px;" v-if="turnGoodsTableList.length>0&&turnGoodsTableList[0].isEnable==1">库存量：
                <span v-if="turnGoodsTableList.length>0"><span class='numbers' style="color:red;">{{turnGoodsTableList[0].KucunAllWeight}}</span>吨</span>
                <span v-if="turnGoodsTableList.length>0">/<span class='numbers' style="color:red;">{{turnGoodsTableList[0].KucunAllNumber}}</span>件</span>
              </span>
            </p>
            <el-table :data="turnGoodsTableList" ref="turnGoodsTableList" border bordersize="mini" style="width: 100%;margin-top:10px;" center :header-cell-style="{background:'#F5F5F5',color:'black'}" :header-row-style="{height:'45px'}" :row-style="{height:'35px'}" highlight-current-row>
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column type="text" width="55" label="操作" align="center">
                <template slot-scope="scope2">
                  <el-button @click="delClick(scope2.$index, scope2.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="件数" align="center" width="100">
                <template slot-scope="scope">
                  <div>
                    <el-input placeholder="输入件数" @input="numContro($event,scope.row)" v-number-input.float="0" maxlength="100" v-model="scope.row.changeNumber" size="mini"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="重量（吨）" align="center" width="100">
                <template slot-scope="scope">
                  <div>
                    <el-input placeholder="" @input="numControB($event,scope.row)" v-number-input.float="4" maxlength="100" v-model="scope.row.changeWeight" size="mini" :disabled='scope.row.outWeighingMethod==1'></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="stockAvailableNumber" label="库存可转" align="center" width="90"></el-table-column>
              <el-table-column prop="customerAvailableNumber" label="客户可转" align="center" width="90"></el-table-column>
              <el-table-column prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
              <el-table-column prop="steelMillName" label="产地" align="center" width="120"></el-table-column>
              <el-table-column prop="specification" label="规格" width="120" align="center"></el-table-column>
              <el-table-column prop="model" label="材质" align="center" width="150"></el-table-column>
              <el-table-column prop="plateNumber" label="车船号" align="center" width="120"></el-table-column>
              <el-table-column prop="shipForecastNo" label="预报编号" align="center" width="300"></el-table-column>
              <el-table-column prop="warehouseName" label="仓位" align="center" width="100"></el-table-column>
              <el-table-column prop="number" label="件数" align="center" width="80"></el-table-column>
              <el-table-column prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
              <el-table-column prop="stockWeight" label="理重（吨）" align="center" width="100"></el-table-column>
              <el-table-column prop="stockPoundWeight" label="过磅净重（吨）" align="center" width="120"></el-table-column>
              <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
            </el-table>
          </div>
        </div>
        <div style="text-align:center;margin:15px;">
          <el-button @click="changeResetForm" size='mini'>取 消</el-button>
          <el-button type="primary" @click="submitForm" size='mini'>转 货</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 移库 -->
    <el-dialog title="移库" :close-on-click-modal="false" :visible.sync="yikuVisible" width="90%" center>
      <el-table :data="yikuTableList" ref="yikuTableList" border bordersize="mini" style="width: 100%;margin-top:10px;" center :header-cell-style="{background:'#F5F5F5',color:'black'}" :header-row-style="{height:'45px'}" :row-style="{height:'35px'}" highlight-current-row>
        <el-table-column prop="primaryCustomerName" label="目标仓位" align="center" width="120">
          <template slot-scope="scope">
            <el-select filterable v-model="scope.row.warehouseIdY" size="mini" placeholder="请选择仓位" clearable>
              <el-option v-for="(item,index) in CangweiOptions" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="stockAvailableNumber" label="可移件数" align="center" width="100"></el-table-column>
        <el-table-column prop="transferNumber" label="移库件数" align="center" width="100">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入件数" @blur="jianInput" v-number-input.float="0" maxlength="100" v-model="scope.row.transferNumberY" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stockWeight" label="移库重量（吨）" align="center" width="120">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入" :disabled="true" v-if="scope.row.inWeighingMethod == '1'" size="mini" v-model="scope.row.stockWeightY"></el-input>
              <el-input placeholder="请输入" v-number-input.float="4" maxlength="100" v-model="scope.row.stockPoundWeightY" size="mini" v-else></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" align="center" width="110"></el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center" width="110"></el-table-column>
        <el-table-column prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column prop="model" label="材质" align="center" width="100"></el-table-column>
        <el-table-column prop="warehouseName" label="仓位" align="center" width="110"></el-table-column>
        <el-table-column prop="number" label="件数" align="center" width="80"></el-table-column>
        <el-table-column prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
        <el-table-column prop="allWeight" label="过磅净重(吨)" align="center" width="130"></el-table-column>
        <el-table-column prop="plateNumber" label="车船号" align="center" width="120"></el-table-column>
        <el-table-column prop="shipForecastNo" label="预报编号" align="center" width="260"></el-table-column>
        <el-table-column prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="yikuQuXiao">取 消</el-button>
        <el-button type="primary" :loading="yikuLoading" @click="yikuOk">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 点击弹框转货按钮 -->
    <el-dialog title="转货申请" :close-on-click-modal="false" :visible.sync="shenQingVisible" @close="shenQingQuXiao('changeFrom')" width="850px" center>
      <div>
        <el-form :model="changeFrom" :validate-on-rule-change="false" :inline="true" ref="changeFrom" class="demo-form-inline" label-width="140px" size="mini" :rules="rules">
          <div class="">
            <el-form-item label="转货后一级货主:" style="margin-top:15px;" prop="primaryCustomerTaxId">
              <el-select v-model="changeFrom.primaryCustomerTaxId" clearable filterable placeholder="请选择" @change="getNewPrimaryCustomerName(changeFrom.primaryCustomerTaxId)" style="width:230px;">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="转货后二级货主:" prop="customerTaxId" style="margin-top:15px;">
              <el-select v-model="changeFrom.customerTaxId" clearable filterable placeholder="请选择" style="width:230px;" @change="getNewSecondaryCustomerName(changeFrom.customerTaxId)">
                <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="装卸费付费方:" prop="loadFeePayer" style="margin-top:15px;">
            <el-select v-model="changeFrom.loadFeePayer" clearable filterable placeholder="请选择" style="width:230px;">
              <el-option
                v-for="(item, index) in fuFeiData"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item label="转货费付费方:" prop="changeFeePayer" style="margin-top:15px;">
              <el-select v-model="changeFrom.changeFeePayer" clearable filterable placeholder="请选择" style="width:230px;">
                <el-option v-for="(item, index) in fuFeiData" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货主单号:" prop="cargoOwnerChangeNo" style="margin-top:15px;">
              <el-input v-model="changeFrom.cargoOwnerChangeNo" maxlength="50" placeholder="请输入客户单号" style="width:230px" size="mini"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="shenQingQuXiao('changeFrom')">取 消</el-button>
        <el-button type="primary" :loading="shenQingLoading" @click="shenqQingOk">确 定</el-button>
      </div>
    </el-dialog>
    <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center" v-if="daoruMark">
      <el-dialog @close="closeDialogFile" title="导入" :visible.sync="daoruMark" :close-on-click-modal="false" width="40%" center>
        <div style="margin: 15px auto" class="el-dialog--center">
          <input type="file" ref="file" accept=".xls, .csv, .xlsx" @change="getFile($event)" />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="closeDialogFile">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getRelationCustomer, // 字典客户
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  addEmptyChange, // 转货保存
  getWeighingMethodList,
  surplusControlWeight,
  getCargoControlList,
  JfgetCustomerAvailableNumber,
  JfgetCustomerStock,
  JfvirtualControlBean
} from '@/api/wms-stock.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, sortArr } from '@/utils/util'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import {
  zidianKuwei,
  stockSummaryList, // 列表查询
  allPieceAndWeight, // 总吨数、总件数
  clearStock,
  stockSummaryImport,
  getAvailableTransferCount, // 获取在库库存可操作件数
  transferWarehouse,
  getCustomerAvailableNumberAccess,
  changeGoodsOwnerS
} from '@/api/wms-access.js'
const Debounce = (fn, t) => {
  let delay = t || 500
  let timer
  return function () {
    let context = this
    let args = arguments

    if (timer) clearTimeout(timer)

    let callNow = !timer
    timer = setTimeout(() => {
      timer = null
    }, delay)

    if (callNow) fn.apply(context, args)
  }
}
export default {
  name: 'yycZaiKuKC',
  data () {
    return {
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00cP008B001',
        '00cP008B002',
        '00cP008B003',
        '00cP008B004',
        '00cP008B005',
        '00cP008B006',
        '00cP008B007',
        '00cP008B008'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 20,
        model: ''
      },
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      numberOptions: [{
        value: '',
        label: '全部'
      }, {
        value: '0',
        label: '0'
      }, {
        value: '-1',
        label: '不为0'
      }],
      CWData: [],
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      value: '',
      tableList: [],
      tabLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      turnMark: false, // 转货弹框
      turnGoodsTableList: [],
      changeFrom: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: '',
        oldOwnerCustomerName: '', // 原货权方名称
        oldOwnerCustomerTaxId: '', // 原货权方纳税人
        changeFeePayer: '',
        loadFeePayer: '1',
        cargoOwnerChangeNo: ''
      },
      turnLoading: false,
      selectionData: [],
      changeNumber: '',
      changeWeight: '',
      isDisable: false,
      totalAllWeight: '0', // 总吨数
      totalNumber: '0', // 总件数
      yikuVisible: false,
      yikuLoading: false,
      yikuTableList: [],
      CangweiOptions: [],
      residue: 0,
      inWeighingMethod: 0,
      disShow: false,
      changeAllWeight: 0,
      changeAllNumber: 0,
      shenQingVisible: false,
      shenQingLoading: false,
      // 导入
      daoruMark: false,
      importDialog: false,
      isDisable1: false,
      file: null,
      isReminder: 0,
      fuFeiData: [{
        value: '0',
        label: '新货主'
      }, {
        value: '1',
        label: '旧货主'
      }],
      rules: {
        primaryCustomerTaxId: [{ required: true, message: '请选择一级货主', trigger: 'change' }],
        customerTaxId: [{ required: true, message: '请选择二级货主', trigger: 'change' }],
        loadFeePayer: [{ required: true, message: '请选择装卸费付费方', trigger: 'change' }],
        changeFeePayer: [{ required: true, message: '请选择转货费付费方', trigger: 'change' }],
        cargoOwnerChangeNo: [{ required: true, message: '请输入货主单号', trigger: 'blur' }]
      },
      message: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycZaiKuKC')
    this.getSeatchData(this.searchFrom)
    this.getVirtualBalingList()
    this.getStockThreadTotalWN(this.searchFrom)
    this.zidianKuweiS()
    this.getRelationCustomerS()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.searchClick()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
  },
  methods: {
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({})
        .then((res) => {
          this.customerData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    turnClick () {
      if (this.selectionData.length == 0) {
        this.$message({ message: '请先选择一条数据', type: 'error' })
        return
      }
      this.yikuVisible = true
      this.zidianKuweiS()
      this.yikuTableList = []
      getAvailableTransferCount(this.selectionData.stockSummaryId)
        .then(res => {
          let obj = {
            warehouseIdY: '',
            transferNumberY: '',
            stockWeightY: '',
            stockPoundWeightY: '',
            allWeightY: '',
            stockAvailableNumber: res,
            ...this.selectionData
          }
          this.yikuTableList.push(obj)
          getWeighingMethodList({
            productType: this.selectionData.productType
          }).then(res => {
            this.$set(this.yikuTableList[0], 'inWeighingMethod', res[0].inWeighingMethod)
          }).catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    yikuQuXiao () {
      this.yikuVisible = false
    },
    yikuOk () {
      console.log(this.yikuTableList[0], 'this.yikuTableList[0]')
      if (this.yikuTableList[0].warehouseIdY == '') {
        this.$message({ message: '请先填写信息', type: 'error' })
        return
      }
      if (this.yikuTableList[0].transferNumberY > this.yikuTableList[0].stockAvailableNumber) {
        this.$message({ message: '移库件数不能大于库存可移件数', type: 'error' })
        return
      }
      if (this.yikuTableList[0].inWeighingMethod == '1') {
        if (this.yikuTableList[0].stockWeightY < 0 || this.yikuTableList[0].stockWeightY == 0) {
          this.$message({ message: '移库重量不能小于或等于0', type: 'error' })
          return
        }
      } else {
        if (this.yikuTableList[0].stockPoundWeightY < 0 || this.yikuTableList[0].stockPoundWeightY == 0) {
          this.$message({ message: '移库重量不能小于或等于0', type: 'error' })
          return
        }
      }

      getWeighingMethodList({
        productType: this.selectionData.productType
      }).then(res => {
        if (res[0].inWeighingMethod == 1) {
          this.$set(this.yikuTableList[0], 'allWeightY', this.yikuTableList[0].stockWeightY)
        } else {
          this.$set(this.yikuTableList[0], 'allWeightY', this.yikuTableList[0].stockPoundWeightY)
        }
        let obj = this.yikuTableList[0]
        this.CangweiOptions.forEach(item => {
          if (item.warehouseId == obj.warehouseIdY) {
            obj.warehouseNameY = item.warehouseName
          }
        })
        transferWarehouse({ stockSummaryId: obj.stockSummaryId, transferNumber: obj.transferNumberY, warehouseId: obj.warehouseIdY, warehouseName: obj.warehouseNameY, stockWeight: obj.stockWeightY, stockPoundWeight: obj.stockPoundWeightY, allWeight: obj.allWeightY })
          .then(res => {
            this.$message({ message: '移库成功', type: 'success' })
            this.yikuVisible = false
            this.getSeatchData()
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    },
    jianInput () {
      if (this.yikuTableList[0].inWeighingMethod == '1') {
        this.yikuTableList[0].stockWeightY = Number(this.yikuTableList[0].transferNumberY / 1 * this.selectionData.singletonWeight / 1).toFixed(4)
      } else {
        this.$set(this.yikuTableList[0], 'stockPoundWeightY', Number(this.yikuTableList[0].transferNumberY / 1 * this.selectionData.avgWeight / 1).toFixed(4))
      }
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      this.goodsName = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      this.specificationVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      this.modelVal = val
      getVirtualBalingList({
        productType: this.goodsName,
        placeOfOrigin: this.placeOfOrigin,
        specification: this.specificationVal,
        model: this.modelVal
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      stockSummaryList(this.searchFrom)
        .then((res) => {
          this.tabLoading = false
          res.list.forEach(item => {
            item.changeWeight = ''
            item.changeNumber = ''
          })
          this.tableList = res.list
          this.turnGoodsTableList.forEach(item => {
            this.tableList.forEach((item1, index) => {
              if (!item1.isYuanZhuanFlag) {
                let a = item.stockSummaryId == item1.stockSummaryId
                item1.isYuanZhuanFlag = a
              }
            })
          })
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          this.$message.error(err.message)
        })
    },
    // 总吨数、总件数
    getStockThreadTotalWN () {
      allPieceAndWeight(this.searchFrom)
        .then((res) => {
          this.totalAllWeight = res.totalWeight
          this.totalNumber = res.totalPiece
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
      this.getStockThreadTotalWN(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20
      }
      this.goodsName = ''
      this.placeOfOrigin = ''
      this.specificationVal = ''
      this.modelVal = ''
      this.selectionData = []
      this.getSeatchData(this.searchFrom)
      this.getStockThreadTotalWN(this.searchFrom)
      this.getVirtualBalingList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      this.$refs.tableRef.toggleRowSelection(row)
      this.selectionData = row
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击转货清单按钮
    turnGoodsClick () {
      // if (this.turnGoodsTableList.length == 0) {
      //   this.$message.error('请点击预转按钮')
      // } else {
      //   this.turnMark = true
      //   this.turnLoading = false
      //   // 获取货物计重方式
      //   getWeighingMethodList({
      //     productType: this.selectionData.productType
      //   })
      //     .then(res => {
      //       if (res.length > 0) this.inWeighingMethod = res[0].inWeighingMethod
      //     })
      //     .catch(err => {
      //       DonMessage.error(err.message)
      //     })
      // }
      if (this.turnGoodsTableList.length == 0) {
        this.$message({ message: '请先选择货物', type: 'error' })
        return
      }
      this.turnMark = true
    },
    numContro (value, row) {
      let val = (value && value.split('')) || []
      if (val != 0) {
        row.changeNumber = val.join('').match(/^\d*(\.?\d{0,1})/g)[0] || null
        this.changeNumber = row.changeNumber
        if (row.inWeighingMethod == '1') {
          row.changeWeight = (row.singletonWeight * this.changeNumber).toFixed(4)
          this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0).toFixed(4)
          this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
        } else {
          row.changeWeight = (row.avgWeight * this.changeNumber).toFixed(4)
          this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0).toFixed(4)
          this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
        }
      } else {
        row.changeNumber = ''
        row.changeWeight = ''
        this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0).toFixed(4)
        this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
      }
    },
    numControB (value, row) {
      let val = (value && value.split('')) || []
      row.changeWeight = val.join('').match(/^\d*(\.?\d{0,4})/g)[0] || null
      this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeWeight / 1, 0).toFixed(4)
    },
    // 获取转货后一级货主名称
    getNewPrimaryCustomerName (val) {
      this.customerData.forEach((item, index) => {
        if (item.taxpayerNumber == val) {
          this.changeFrom.newPrimaryCustomerName = item.custerName
        }
      })
    },
    // 获取转货后二级货主名称
    getNewSecondaryCustomerName (val) {
      this.customerData.forEach((item, index) => {
        if (item.taxpayerNumber == val) {
          this.changeFrom.newSecondaryCustomerName = item.custerName
        }
      })
    },
    // 点击转货按钮
    submitForm () {
      if (this.turnGoodsTableList.length == 0) {
        DonMessage.error('请点击预转添加转货清单')
      } else {
        let turnJian = this.turnGoodsTableList.reduce((pre, cur) => { return pre / 1 + cur.changeNumber / 1 }, 0)
        for (let i = 0; i < this.turnGoodsTableList.length; i++) {
          if (this.turnGoodsTableList[i].changeNumber > this.turnGoodsTableList[i].stockAvailableNumber) {
            this.$message({ message: '件数不能大于库存可转件数', type: 'error' })
            return
          } else if (this.turnGoodsTableList[i].changeNumber > this.turnGoodsTableList[i].customerAvailableNumber) {
            this.$message({ message: '件数不能大于客户可转件数', type: 'error' })
            return
          } else if (this.turnGoodsTableList[i].changeNumber / 1 == 0) {
            this.$message({ message: '件数不能为0', type: 'error' })
            return
          } else if (this.turnGoodsTableList[i].changeWeight / 1 == 0 || this.turnGoodsTableList[i].changeWeight / 1 < 0) {
            this.$message({ message: '重量不能小于等于0', type: 'error' })
            return
          } else if (this.turnGoodsTableList[i].strictReminder == 0 && this.turnGoodsTableList[i].isEnable == 1 && this.turnGoodsTableList[i].controlPiece == 1 && turnJian > this.turnGoodsTableList[0].controlStockNumber) {
            this.$message({ message: '件数不能大于未提件数', type: 'error' })
            return
          } else if (this.turnGoodsTableList[i].strictReminder == 0 && this.turnGoodsTableList[i].isEnable == 1 && this.turnGoodsTableList[i].controlWeight == 1 && this.changeAllWeight > this.turnGoodsTableList[i].controlStockWeight) {
            this.$message({ message: '重量不能大于未提吨数', type: 'error' })
            return
          }
        }
        if (this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].controlPiece == 1 && turnJian > this.turnGoodsTableList[0].controlStockNumber) {
          console.log(3333, turnJian, this.turnGoodsTableList[0].controlStockNumber)
          this.$message({ message: '总件数不能大于未提件数', type: 'error' })
          return
        } else if (this.turnGoodsTableList[0].strictReminder == 1 && this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].controlWeight == 1 && this.changeAllWeight > this.turnGoodsTableList[0].controlStockWeight) {
          this.message = '转货总重量超过未提量，是否继续转货？'
        }
        if ((this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].strictReminder == 0) || this.turnGoodsTableList[0].isEnable == 2 || (this.turnGoodsTableList[0].isEnable == 1 && this.turnGoodsTableList[0].strictReminder == 1 && this.changeAllWeight <= this.turnGoodsTableList[0].controlStockWeight)) {
          this.shenQingVisible = true
        } else {
          this.$confirm(this.message, '提示', {
            confirmButtonText: '确定并继续',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.shenQingVisible = true
            this.isReminder = 1
          }).catch(() => {

          })
        }
      }
    },
    // 点击转货取消
    changeResetForm () {
      this.turnMark = false
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
    },
    // 转货弹框X关闭
    closeDialog () {
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
    },
    // 清零
    clearBtn () {
      if (this.selectionData.stockSummaryId == undefined) {
        this.$message.error('请选择一条数据进行操作')
      } else if (this.selectionData.number != '0') {
        DonMessage.error('您所选的数据存在件数不为0')
      } else {
        this.$confirm('清零后数据不可恢复，确定清零吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          clearStock(this.selectionData.stockSummaryId).then((res) => {
            this.$message.success('操作成功')
            this.getSeatchData(this.searchFrom)
          }).catch((err) => {
            this.$message.error(err.message)
          })
        }).catch(() => {
        })
      }
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsAccessName + '/shipStock/stockSummary/export',
        this.searchFrom,
        '在库库存信息表'
      )
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.CangweiOptions = res
          this.CWData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    surplusControlWeights (primaryCustomerTaxId, customerTaxId) {
      getCargoControlList({ primaryCustomerTaxId: primaryCustomerTaxId, secondaryCustomerId: customerTaxId })
        .then(res => {
          if (res.length > 0) {
            this.disShow = true
            surplusControlWeight({
              oneCustomerTaxId: primaryCustomerTaxId,
              twoCustomerTaxId: customerTaxId,
              organizationId: window.localStorage.getItem('tenantCode')
            })
              .then(res => {
                this.residue = res
              })
          } else {
            this.disShow = false
          }
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    getCustomerAvailableNumbers (obj, row) {

    },
    // 点预转
    PreSelect: Debounce(function (index, row) {
      let hadselect = false
      this.turnGoodsTableList.forEach(item => {
        if (item.stockSummaryId == row.stockSummaryId) {
          hadselect = true
        }
      })
      if (this.turnGoodsTableList.length > 0 && (row.primaryCustomerTaxId != this.turnGoodsTableList[0].primaryCustomerTaxId || row.customerTaxId != this.turnGoodsTableList[0].customerTaxId)) {
        this.$message({ message: '一级货主二级货主必须相同', type: 'error' })
      } else if (hadselect) {
        this.$message({ message: '不可重复选择', type: 'error' })
      } else {
        getCustomerAvailableNumberAccess({
          stockSummaryId: row.stockSummaryId
        })
          .then(res => {
            row.customerAvailableNumber = res
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
        console.log(row, 'row')
        JfvirtualControlBean({
          oneCustomerTaxId: row.primaryCustomerTaxId,
          twoCustomerTaxId: row.customerTaxId,
          organizationId: window.localStorage.getItem('tenantCode'),
          productionPlaceName: row.steelMillName,
          specificationName: row.specification,
          materialName: row.model,
          goodTypeName: row.productTypeName
        })
          .then(res => {
            console.log(res)
            let jsonRes = JSON.parse(res)
            console.log(jsonRes)
            row.isEnable = jsonRes.isEnable
            row.controlPiece = jsonRes.controlPiece
            row.controlWeight = jsonRes.controlWeight
            row.controlStockWeight = jsonRes.controlStockWeight ? jsonRes.controlStockWeight : 0
            row.controlStockNumber = jsonRes.controlStockNumber ? jsonRes.controlStockNumber : 0
            row.strictReminder = jsonRes.strictReminder
            JfgetCustomerStock({
              primaryCustomerTaxId: row.primaryCustomerTaxId,
              customerTaxId: row.customerTaxId,
              productType: jsonRes.goodTypeName,
              steelMillName: jsonRes.productionPlaceName,
              specification: jsonRes.specificationName,
              model: jsonRes.materialName
            })
              .then(res => {
                console.log(res)
                row.KucunAllWeight = res.totalAllWeight
                row.KucunAllNumber = res.totalNumber
              })
              .catch(err => {
                this.$message({ message: err.message, type: 'error' })
              })
            if (this.turnGoodsTableList.length == 0) {
              getAvailableTransferCount(row.stockSummaryId)
                .then(res => {
                  row.stockAvailableNumber = res
                  this.$set(row, 'changeNumber', '')
                  this.$set(row, 'changeWeight', '')
                  this.$set(row, 'isYuanZhuanFlag', true)
                  getWeighingMethodList(
                    {
                      productType: row.productType
                    }
                  )
                    .then(res => {
                      console.log(res)
                      if (res.length > 0) row.outWeighingMethod = res[0].outWeighingMethod
                      row.RowStr = row.isEnable == 2 ? '不控货' : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}${jsonRes.specificationName ? jsonRes.specificationName : ''}${jsonRes.materialName ? jsonRes.materialName : ''}` == '' ? '总控' : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`
                      this.turnGoodsTableList.push(row)
                    })
                    .catch(err => {
                      this.$message({ message: err.message, type: 'error' })
                    })
                })
                .catch(err => {
                  this.$message({ message: err.message, type: 'error' })
                })
            } else {
              console.log(res)
              let Str = `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`
              // let RowStr = `${this.turnGoodsTableList[0].steelMillName ? this.turnGoodsTableList[0].steelMillName : ''}${this.turnGoodsTableList[0].productTypeName ? this.turnGoodsTableList[0].productTypeName : ''}${this.turnGoodsTableList[0].specification ? this.turnGoodsTableList[0].specification : ''}${this.turnGoodsTableList[0].model ? this.turnGoodsTableList[0].model : ''}`
              console.log(this.turnGoodsTableList[0].RowStr, Str)
              if (this.turnGoodsTableList[0].isEnable == jsonRes.isEnable) {
                if ((this.turnGoodsTableList[0].isEnable == 1 && Str == this.turnGoodsTableList[0].RowStr) || this.turnGoodsTableList[0].isEnable == 2) {
                  getAvailableTransferCount(row.stockSummaryId)
                    .then(res => {
                      row.stockAvailableNumber = res
                      this.$set(row, 'changeNumber', '')
                      this.$set(row, 'changeWeight', '')
                      this.$set(row, 'isYuanZhuanFlag', true)
                      getWeighingMethodList(
                        {
                          productType: row.productType
                        }
                      )
                        .then(res => {
                          console.log(res)
                          if (res.length > 0) row.outWeighingMethod = res[0].outWeighingMethod
                          row.RowStr = row.isEnable == 2 ? '不控货' : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}${jsonRes.specificationName ? jsonRes.specificationName : ''}${jsonRes.materialName ? jsonRes.materialName : ''}` == '' ? '总控' : `${jsonRes.productionPlaceName ? jsonRes.productionPlaceName : ''}|${jsonRes.goodTypeName ? jsonRes.goodTypeName : ''}|${jsonRes.specificationName ? jsonRes.specificationName : ''}|${jsonRes.materialName ? jsonRes.materialName : ''}`

                          this.turnGoodsTableList.push(row)
                        })
                        .catch(err => {
                          this.$message({ message: err.message, type: 'error' })
                        })
                    })
                    .catch(err => {
                      this.$message({ message: err.message, type: 'error' })
                    })
                } else {
                  this.$message({ message: '控货类型不同，不可选择', type: 'error' })
                }
              } else {
                this.$message({ message: '控货类型不同，不可选择', type: 'error' })
              }
            }
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }

      // this.surplusControlWeights(row.primaryCustomerTaxId, row.customerTaxId)
    }),
    isYuZhuanShow (row) {
      const that = this
      this.turnGoodsTableList.forEach((item1, index) => {
        let a = row.stockSummaryId == item1.stockSummaryId
        that.$set(row, 'isYuanZhuanFlag', a)
        // row.isYuanZhuanFlag = a
      })
    },
    quXiaoYuZhuan (index, row) {
      for (let a = 0; a < this.turnGoodsTableList.length; a++) {
        if (this.turnGoodsTableList[a].stockSummaryId == row.stockSummaryId) {
          this.turnGoodsTableList.splice(a, 1)
          this.$set(row, 'isYuanZhuanFlag', false)
        }
      }
      this.changeAllWeight = this.turnGoodsTableList.reduce((pre, cur) => { return pre / 1 + cur.changeWeight / 1 }, 0)
      this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
    },
    clearArr () {
      this.turnGoodsTableList = []
      this.changeAllWeight = 0
      this.changeAllNumber = 0
      this.tableList.map(function (item) {
        item.isYuanZhuanFlag = false
      })
    },
    delClick (index, row) {
      this.turnGoodsTableList.splice(index, 1)
      const that = this
      if (this.turnGoodsTableList.length == 0) {
        this.tableList.map(function (item) {
          that.$set(item, 'isYuanZhuanFlag', false)
          // item.isYuanZhuanFlag = false
        })
      } else {
        this.isYuZhuanShow(row)
      }
      this.changeAllWeight = Number(this.changeAllWeight / 1 - row.changeWeight / 1).toFixed(4)
      this.changeAllNumber = this.turnGoodsTableList.reduce((pre, cur) => pre / 1 + cur.changeNumber / 1, 0)
    },
    shenQingQuXiao (formName) {
      this.$refs[formName].resetFields()
      this.shenQingVisible = false
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
      this.changeFrom.newPrimaryCustomerName = ''
      this.changeFrom.newSecondaryCustomerName = ''
      this.changeFrom.primaryCustomerTaxId = ''
      this.changeFrom.customerTaxId = ''
      this.changeFrom.changeFeePayer = ''
      this.changeFrom.loadFeePayer = '1'
      this.changeFrom.cargoOwnerChangeNo = ''
    },
    shenqQingOk () {
      this.$refs.changeFrom.validate((valid) => {
        if (valid) {
          this.shenQingLoading = true
          let obj
          let arrs = this.turnGoodsTableList[0].RowStr.split('|')
          console.log(arrs)
          if (arrs.length == 4) {
            obj = {
              primaryCustomerTaxId: this.turnGoodsTableList[0].primaryCustomerTaxId,
              customerTaxId: this.turnGoodsTableList[0].customerTaxId,
              steelMillName: arrs[0],
              productType: arrs[1],
              specification: arrs[2],
              model: arrs[3]
            }
          }
          console.log(obj)
          changeGoodsOwnerS({
            oldOwnerCustomerName: this.turnGoodsTableList[0].ownerCustomerName, // 原货权方名称
            oldOwnerCustomerTaxId: this.turnGoodsTableList[0].ownerCustomerTaxId, // 原货权方纳税人
            newPrimaryCustomerId: this.changeFrom.primaryCustomerTaxId,
            newPrimaryCustomerName: this.changeFrom.newPrimaryCustomerName,
            newSecondaryCustomerId: this.changeFrom.customerTaxId,
            newSecondaryCustomerName: this.changeFrom.newSecondaryCustomerName,
            changeFeePayer: this.changeFrom.changeFeePayer,
            loadFeePayer: this.changeFrom.loadFeePayer,
            cargoOwnerChangeNo: this.changeFrom.cargoOwnerChangeNo,
            oldPrimaryCustomerId: this.turnGoodsTableList[0].primaryCustomerTaxId,
            oldPrimaryCustomerName: this.turnGoodsTableList[0].primaryCustomerName,
            oldSecondaryCustomerId: this.turnGoodsTableList[0].customerTaxId,
            oldSecondaryCustomerName: this.turnGoodsTableList[0].customerName,
            changeDetailList: this.turnGoodsTableList,
            cargoControlKey: this.turnGoodsTableList[0].RowStr,
            isReminder: this.isReminder,
            changeType: '1', // 1：转货 2：回购 3：钢厂转货
            ...obj
          })
            .then(res => {
              console.log(res)
              this.$message.success('保存成功')
              this.shenQingLoading = false
              this.shenQingVisible = false
              this.turnMark = false
              this.turnGoodsTableList = []
              this.changeAllWeight = 0
              this.changeAllNumber = 0
              this.getSeatchData(this.searchFrom)
            })
            .catch(err => {
              this.shenQingLoading = false
              this.$message({ message: err.message, type: 'error' })
            })
        } else {
          this.shenQingLoading = false
        }
      })
    },
    // 点击导入
    importFn () {
      this.daoruMark = true
      this.file = []
    },
    closeDialogFile () {
      this.daoruMark = false
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    // 导入-确定
    daoruQueding (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (name == false) {
        DonMessage.error('文件为空,请选择文件进行导入')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        DonMessage.error('请选择正确的文件格式')
      } else {
        let formData = new FormData()
        formData.append('file', this.file)
        this.isDisable1 = true
        stockSummaryImport(formData)
          .then((res) => {
            // -1 提示错误信息， 0 成功， 1显示导出异常
            this.daoruMark = false
            this.isDisable1 = false
            if (res.keyList.length > 0) {
              this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  const loading = this.$loading({
                    lock: true,
                    text: '正在导出异常信息...'
                  })
                  exportExcel(
                    this.global.wmsAccessName + '/railwayForecast/exportErrorInfo',
                    res.keyList,
                    '导入记录异常表'
                  )
                  setTimeout(() => {
                    this.$message({
                      type: 'success',
                      message: '异常信息导出成功!'
                    })
                    loading.close()
                    this.getSeatchData(this.searchFrom)
                    this.getStockThreadTotalWN(this.searchFrom)
                    this.daoruMark = false
                  }, 3000)
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消导出'
                  })
                })
            } else {
              this.$message({
                message: res.successInfo,
                type: 'success'
              })
            }
            this.getSeatchData(this.searchFrom)
            this.getStockThreadTotalWN(this.searchFrom)
          })
          .catch((err) => {
            if (err.code == -1) {
              this.$message({
                message: err.data == null ? err.message : err.data,
                type: 'error'
              })
            }
            this.isDisable1 = false
          })
      }
    },
    // 模板导出
    templateImport () {
      // console.log(this.searchFrom.customerTaxId, 'this.searchFrom.customerTaxId')
      if (this.searchFrom.customerTaxId == '' || this.searchFrom.customerTaxId == undefined || this.searchFrom.customerTaxId == null) {
        this.$message({ message: '请选择二级货主', type: 'error' })
      } else {
        exportExcel(
          this.global.wmsAccessName + '/shipStock/stockSummaryTemplateExport',
          this.searchFrom,
          '库存明细'
        )
      }
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 40px;
}
.inpBox {
  margin: 5px 0 0 -30px;
}
/deep/.inpBox .el-input__inner {
  width: 150px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -35px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
.addstyle {
  margin-left: 94%;
}
.addMarkBox {
  .addMarkBox-title {
    width: 150px;
    font-size: 18px;
    font-weight: 700;
    margin: 0 auto;
  }
  .addMarkBox-content {
    width: 45%;
    margin: 30px auto;
    div {
      padding-bottom: 5px;
      font-weight: 700;
      .ipt {
        width: 150px;
      }
    }
  }
}
.imgDialog {
  width: 100%;
  text-align: center;
  img {
    height: calc(100vh - 250px);
  }
}
//查看凭证弹窗 -放大
.oneTwo {
  z-index: 11111 !important;
}
.img_box {
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    padding: 2px;
    img {
      width: 150px;
      height: 150px;
      margin-left: 50px;
    }
  }
}
.numbers {
  margin-left: 10px;
  margin-right: 10px;
  color: red;
}
.box1 {
  overflow: hidden;
}
.leftbox {
  width: 250px;
  float: left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y: auto;
}
.rightbox {
  margin-left: 50px;
  width: 850px;
  float: left;
  .pdfbox {
    height: calc(100vh - 250px);
  }
}
</style>
